import {
  AttachmentsList,
  CustomButton,
  PdfViewer,
  SvgDownloadGrey,
  SvgVerticalSplitter,
  Tooltip,
} from '@ui-kit'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import { EMAIL_PREVIEW } from '../../constants/intakeQue.constants'
import { emailContent } from '../../mock-data/intakeEmailDummyData.mock'

const CommunicationPreview = ({ ...props }) => {
  const getPreviewCommunicationView = () => {
    if (props?.intakeType === QUEUE_STRINGS.EMAIL) {
      if (props?.previewData.isPreview) {
        return (
          <div className="flex flex-col gap-3 min-w-[36rem] view-fax-wrap border-2 m-[0.875rem] p-2.5">
            <div className="flex justify-between items-center">
              <div className="font-semibold">{props?.previewData.subject}</div>
              <div className="flex items-center gap-2">
                <CustomButton
                  type="button"
                  color="others"
                  widthClass="w-[92px]"
                  className="h-[40px] gap-2 border-[1px] rounded-tl-[4px] back-btn border-primary-500"
                  isFilled={true}
                  onClick={() =>
                    props?.setPreviewData({
                      subject: '',
                      content: '',
                      id: '',
                      isPreview: false,
                    })
                  }
                  data-qa-id="back-to-email-review"
                >
                  {EMAIL_PREVIEW.BACK}
                </CustomButton>
                <SvgVerticalSplitter />
                <Tooltip content={'Download'}>
                  <CustomButton
                    type="button"
                    color="others"
                    widthClass="w-[40px]"
                    horizontalPaddingClasses="px-[0rem]"
                    className="h-[40px] "
                    isFilled={true}
                    onClick={() => props?.downloadFile()}
                    data-qa-id="download-file"
                  >
                    <SvgDownloadGrey />
                  </CustomButton>
                </Tooltip>
              </div>
            </div>
            <div className="border-t-2"></div>
            {/* <PdfViewer pdfUrl={`${props?.faxUrl}`} /> */}
            <div
              dangerouslySetInnerHTML={{
                __html: emailContent,
              }}
            />
          </div>
        )
      } else {
        return (
          <div className="flex flex-col gap-3 min-w-[36rem] view-fax-wrap border-2 m-[0.875rem] p-2.5">
            <div className="font-semibold">
              {EMAIL_PREVIEW.PATIENT_ENROLLMENT}
            </div>
            <div className="border-t-2"></div>

            <AttachmentsList
              onOptionClick={props?.handleOptionClick}
              attachments={props?.attachments}
              maximumVisibleAttachmentCount={2}
            />

            <div className="border-t-2"></div>
            {/*TODO: Use dangerous div later */}
            {/* <PdfViewer pdfUrl={`${props?.faxUrl}`} /> */}
            <div
              dangerouslySetInnerHTML={{
                __html: emailContent,
              }}
            />
          </div>
        )
      }
    } else {
      return <PdfViewer pdfUrl={`${props?.faxUrl}`} />
    }
  }
  if (props?.intakeType === QUEUE_STRINGS.WEB) {
    return (
      // <AddEditRecordPage
      //   mode="view"
      //   entityId={caseEntityId?.toString()}
      //   id={id?.toString() ?? ''}
      //   loaderVisible={false}
      //   allowNavigate={false}
      //   onSaveClick={props?.onSaveClick}
      //   shouldModalOpen={false}
      //   onCancel={() => {
      //     props?.setIsEditModalOpen(false)
      //   }}
      //   showFooter={false}
      //   showHeader={false}
      // />

      <div className="min-w-[100%] view-fax-wrap flex-col">
        <PdfViewer pdfUrl={`${props?.faxUrl}`} />
      </div>
    )
  }

  return getPreviewCommunicationView()
}
export default CommunicationPreview
